import { APPS } from "./constants";

export const getUrl = (app) => {
  const hostname = window && window.location && window.location.hostname;

  switch (app) {
    case APPS.go_admin:
      if (hostname !== "localhost" && !hostname.includes("staging")) {
        return "https://sa.goapps.app";
      }
      if (hostname === "localhost") {
        return "http://localhost:3001";
      }
      return "https://staging-sa.goapps.app";
    case APPS.go_write_teacher:
      if (
        hostname !== "localhost" &&
        !hostname.includes("staging") &&
        hostname.includes("boom")
      ) {
        return "https://write-teachers.boomhub.app";
      }
      if (hostname !== "localhost" && !hostname.includes("staging")) {
        return "https://teachers.go-write.app";
      }
      if (hostname === "localhost") {
        return "http://localhost:3002";
      }
      if (hostname.includes("boom")) {
        return "https://staging.write-teachers.boomhub.app";
      }
      return "https://staging-teachers.go-write.app";
    case APPS.go_write_pupil:
      if (
        hostname !== "localhost" &&
        !hostname.includes("staging") &&
        hostname.includes("boom")
      ) {
        return "https://write-pupils.boomhub.app";
      }
      if (hostname !== "localhost" && !hostname.includes("staging")) {
        return "https://pupils.go-write.app";
      }
      if (hostname === "localhost") {
        return "http://localhost:3003";
      }
      if (hostname.includes("boom")) {
        return "https://staging.write-pupils.boomhub.app";
      }
      return "https://staging-pupils.go-write.app";
    case APPS.go_read_teacher:
      if (
        hostname !== "localhost" &&
        !hostname.includes("staging") &&
        hostname.includes("boom")
      ) {
        return "https://read-teachers.boomhub.app";
      }
      if (hostname !== "localhost" && !hostname.includes("staging")) {
        return "https://teachers.go-read.app";
      }
      if (hostname === "localhost") {
        return "http://localhost:3004";
      }
      if (hostname.includes("boom")) {
        return "https://staging.read-teachers.boomhub.app";
      }
      return "https://staging-teachers.go-read.app";

    case APPS.go_read_pupil:
      if (
        hostname !== "localhost" &&
        !hostname.includes("staging") &&
        hostname.includes("boom")
      ) {
        return "https://read-pupils.boomhub.app";
      }
      if (hostname !== "localhost" && !hostname.includes("staging")) {
        return "https://pupils.go-read.app";
      }
      if (hostname === "localhost") {
        return "http://localhost:3005";
      }
      if (hostname.includes("boom")) {
        return "https://staging.read-pupils.boomhub.app";
      }
      return "https://staging-pupils.go-read.app";
    case APPS.go_portal_teacher:
      if (
        hostname !== "localhost" &&
        !hostname.includes("staging") &&
        hostname.includes("boom")
      ) {
        return "https://boomhub.app";
      }
      if (hostname !== "localhost" && !hostname.includes("staging")) {
        return "https://teachers.goapps.app";
      }
      if (hostname === "localhost") {
        return "http://localhost:3006";
      }
      if (hostname.includes("boom")) {
        return "https://staging.boomhub.app";
      }
      return "https://staging-teachers.goapps.app";
    case APPS.go_portal_pupil:
      if (
        hostname !== "localhost" &&
        !hostname.includes("staging") &&
        hostname.includes("boom")
      ) {
        return "https://pupils.boomhub.app";
      }
      if (hostname !== "localhost" && !hostname.includes("staging")) {
        return "https://pupils.goapps.app";
      }
      if (hostname === "localhost") {
        return "http://localhost:3007";
      }
      if (hostname.includes("boom")) {
        return "https://staging.pupils.boomhub.app";
      }
      return "https://staging-pupils.goapps.app";
    case APPS.boom_math_teacher:
      if (hostname !== "localhost" && !hostname.includes("staging")) {
        return "https://math-teachers.boomhub.app";
      }
      if (hostname === "localhost") {
        return "http://localhost:3009";
      }
      return "https://staging.math-teachers.boomhub.app";
    case APPS.boom_math_pupil:
      if (hostname !== "localhost" && !hostname.includes("staging")) {
        return "https://math-pupils.boomhub.app";
      }
      if (hostname === "localhost") {
        return "http://localhost:3010";
      }
      return "https://staging.math-pupils.boomhub.app";
    case APPS.go_parents_desktop:
      if (
        hostname !== "localhost" &&
        !hostname.includes("staging") &&
        hostname.includes("boom")
      ) {
        return "https://parents.boomhub.app";
      }
      if (hostname !== "localhost" && !hostname.includes("staging")) {
        return "https://parents.goapps.app";
      }
      if (hostname === "localhost") {
        return "http://localhost:3008";
      }
      if (hostname.includes("boom")) {
        return "https://staging.parents.boomhub.app";
      }
      return "https://staging-parents.goapps.app";
    default:
      return null;
  }
};
